export default __webpack_public_path__ + "static/media/image 122.2647c882.png";